module.exports = __webpack_public_path__ + "img/hail.83c5ba00.svg";